// v1 Audit Queue endpoint paths. Shared by audit-queue-api.ts and
// audit-queue-service.ts so both callers stay on the same routes.
// The old /audit/* routes were removed with no alias (UX Modernization route
// rename) — query params and response shapes are unchanged.
export const AUDIT_ROUTES = {
  list: "/api/v1/audits",
  detail: (auditId: number | string) => `/api/v1/audits/${auditId}`,
  kpis: "/api/v1/audits/kpis",
  urgent: "/api/v1/audits/urgent",
  auditTypeOptions: "/api/v1/audits/audit-type/options",
  auditorOptions: "/api/v1/audits/auditor/options",
  auditPeriodOptions: "/api/v1/audits/audit-period/options",
} as const;
